import { render, staticRenderFns } from "./balance-trans-detail.vue?vue&type=template&id=2521a699&scoped=true"
import script from "./balance-trans-detail.vue?vue&type=script&lang=js"
export * from "./balance-trans-detail.vue?vue&type=script&lang=js"
import style0 from "./balance-trans-detail.vue?vue&type=style&index=0&id=2521a699&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521a699",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2521a699')) {
      api.createRecord('2521a699', component.options)
    } else {
      api.reload('2521a699', component.options)
    }
    module.hot.accept("./balance-trans-detail.vue?vue&type=template&id=2521a699&scoped=true", function () {
      api.rerender('2521a699', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/balance-trans-detail.vue"
export default component.exports